/**
 * Pure date-window helpers for the agency viewings reads (Lot 4 — bounding the
 * previously unbounded `agency_viewings` listener). Extracted so the window
 * sizes are unit-pinned independently of the Firestore query wiring (which uses
 * raw `@angular/fire/firestore` module functions and isn't isolable in a unit
 * test). A regression that shrinks/loses the window is caught here.
 */

/** Days of history the rolling `viewings$()` window keeps (plus all future). */
export const VIEWINGS_WINDOW_DAYS = 90;

/** Padding each side of the calendar's visible period, covering the month grid's
 *  overflow weeks plus week/day views. */
export const VIEWINGS_CALENDAR_BUFFER_DAYS = 60;

/** Lower bound for `viewings$()` — `now` minus the rolling window. Pure; never
 *  mutates the input. */
export function viewingsWindowStart(now: Date, days: number = VIEWINGS_WINDOW_DAYS): Date {
  const d = new Date(now);
  d.setDate(d.getDate() - days);
  return d;
}

/** `[from, to]` range the calendar queries for a given `viewDate`, padded by
 *  `bufferDays` each side. Pure; never mutates the input. */
export function viewingsCalendarRange(
  viewDate: Date,
  bufferDays: number = VIEWINGS_CALENDAR_BUFFER_DAYS,
): { from: Date; to: Date } {
  const from = new Date(viewDate);
  from.setDate(from.getDate() - bufferDays);
  const to = new Date(viewDate);
  to.setDate(to.getDate() + bufferDays);
  return { from, to };
}
